import { HttpErrorResponse } from '@angular/common/http';
import {
  AfterViewInit,
  Component,
  Inject,
  OnInit,
  ViewChild
} from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators
} from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogConfig,
  MatDialogRef
} from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { CategoriaMateriaPrimaService } from '@app/modules/categoria-materia-prima/services/categoria_materia_prima.service';
import { IMateriaPrima } from '@app/modules/materia-prima/models/materia-prima.model';
import { MateriaPrimaService } from '@app/modules/materia-prima/services/materia-prima.service';
import { UnidadeService } from '@app/modules/materia-prima/services/unidade.service';
import {
  ConfirmDialogComponent,
  ConfirmDialogData
} from '@app/shared/components';
import { Utils } from '@app/shared/helpers/utils';
import { ScreenService } from '@app/shared/services';
import { Dialog } from 'primeng/dialog';
import { filter, finalize, map, mergeMap } from 'rxjs/operators';

import {
  CustomValidators,
  ErroMessages,
  IErroMessages,
  IRoute,
  TokenService
} from 'viggo-sistemas-core-web';

@Component({
  templateUrl: './fast-materia-prima.component.html',
  styleUrls: ['./fast-materia-prima.component.scss'],
  providers: [MateriaPrimaService, CategoriaMateriaPrimaService, UnidadeService]
})
export class FastMateriaPrimaComponent implements OnInit, AfterViewInit {
  @ViewChild('fastMP') fastMP: Dialog;
  public form: UntypedFormGroup;
  descricao_categoria: string;
  loading = false;
  showConversao = false;

  displayMessage = {
    descricao: {
      required: 'Descrição é obrigatória',
      maxlength: 'Não pode ter mais de 60 caracteres',
      isEmptyValue: 'Valor inválido: remova os campos em branco!',
      repeated: 'Já existe uma matéria prima com essa descrição'
    },
    taxa_conversao: {
      required: 'Taxa de conversão é obrigatório',
      valueMinZero: 'Valor não pode ser 0',
      min: 'Taxa deve ser maior que 0',
      max_value: 'Inválido: passou dos limite',
      before_split: 'Inválido: erro na parte inteira',
      after_split: 'Inválido: erro na parte decimal',
      errorComma: 'Inválido: excesso de virgulas',
      errorDots: 'Inválido: excesso de pontos',
      notNumbers: 'Inválido: insira um número',
      invalidNumber: 'Valor inválido'
    },
    quantidade: {
      required: 'Quantidade é obrigatória',
      max_value: 'Inválido: passou dos limite',
      before_split: 'Inválido: erro na parte inteira',
      after_split: 'Inválido: erro na parte decimal',
      errorComma: 'Inválido: excesso de virgulas',
      errorDots: 'Inválido: excesso de pontos',
      notNumbers: 'Inválido: insira um número',
      invalidNumber: 'Valor inválido'
    },
    qtd_minima: {
      required: 'Quantidade mínima é obrigatória',
      max_value: 'Inválido: passou dos limite',
      before_split: 'Inválido: erro na parte inteira',
      after_split: 'Inválido: erro na parte decimal',
      errorComma: 'Inválido: excesso de virgulas',
      errorDots: 'Inválido: excesso de pontos',
      notNumbers: 'Inválido: insira um número',
      invalidNumber: 'Valor inválido'
    },
    valor: {
      required: 'Valor é obrigatório',
      min: 'Valor deve ser maior que 0',
      max_value: 'Inválido: passou dos limite',
      before_split: 'Inválido: erro na parte inteira',
      after_split: 'Inválido: erro na parte decimal',
      errorComma: 'Inválido: excesso de virgulas',
      errorDots: 'Inválido: excesso de pontos',
      notNumbers: 'Inválido: insira um número',
      invalidNumber: 'Valor inválido'
    },
    localizador: {
      maxlength: 'Não pode ter mais de 100 caracteres',
      isEmptyValue: 'Valor inválido: remova os campos em branco!'
    }
  };

  constructor(
    public screenService: ScreenService,
    public dialogRef: MatDialogRef<FastMateriaPrimaComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { entity: IMateriaPrima },
    protected fb: UntypedFormBuilder,
    public entityService: MateriaPrimaService,
    public categoriaMateriaPrimaService: CategoriaMateriaPrimaService,
    public unidadeService: UnidadeService,
    public tokenService: TokenService,
    public matSnackBar: MatSnackBar,
    public matDialog: MatDialog,
    public router: Router
  ) {
    this.descricao_categoria = data.entity.descricao_categoria;
  }

  ngAfterViewInit(): void {
    if (this.screenService.detectDeviceInfo().isMobile)
      this.fastMP.maximize();
  }

  ngOnInit() {
    this.form = this.fb.group({
      descricao: [
        '',
        [
          Validators.required,
          Validators.maxLength(150),
          CustomValidators.isEmptyValue()
        ]
      ],
      unidade: [
        null,
        [
          Validators.required,
          CustomValidators.typeIs('object'),
          CustomValidators.isEmptyValue()
        ]
      ],
      categoria: [
        null,
        [
          Validators.required,
          CustomValidators.typeIs('object'),
          CustomValidators.isEmptyValue()
        ]
      ],
      taxa_conversao: [
        null,
        [
          Validators.required,
          CustomValidators.validateCurrencyValues(17, 4),
          CustomValidators.validateEqualsMinZero()
        ]
      ],
      valor: [
        0,
        [Validators.required, CustomValidators.validateCurrencyValues(15, 2)]
      ],
      quantidade: [
        0,
        [Validators.required, CustomValidators.validateCurrencyValues(17, 4)]
      ],
      qtd_minima: [
        0,
        [Validators.required, CustomValidators.validateCurrencyValues(17, 4)]
      ],
      localizador: [
        '',
        [Validators.maxLength(100), CustomValidators.isEmptyValue()]
      ]
      // usa_grade: [false, [Validators.required]]
    });

    const { taxa_conversao } = this.form.controls;

    if (this.descricao_categoria !== 'TECIDO') {
      taxa_conversao.setValue(0);
    }

    this.validateForm();
  }

  onSubmit() {
    if (this.form.valid) {
      this.loading = true;
      const { ...rest } = this.form.value;
      var entity = Utils.trimAttributes({
        domain_id: this.tokenService.getDomain().id,
        ...rest
      });
      entity.taxa_conversao = this.showConversao
        ? Utils.replaceCommaToDot(entity.taxa_conversao)
        : 0;
      entity.categoria_id = entity.categoria.id;
      entity.unidade_id = entity.unidade.id;
      entity.valor = Utils.replaceCommaToDot(entity.valor);
      entity.quantidade = Utils.replaceCommaToDot(entity.quantidade);
      entity.qtd_minima = Utils.replaceCommaToDot(entity.qtd_minima);
      delete entity.unidade;
      delete entity.categoria;
      this.entityService
        .insert(entity)
        .pipe(
          mergeMap(res => {
            const req = this.entityService.getEntity(
              res.id,
              'unidade,categoria'
            );
            return req.pipe(
              map(ent => {
                return { ...ent };
              })
            );
          })
        )
        .subscribe(
          materia_prima => {
            if (materia_prima) {
              this.matSnackBar.open(
                `Nova matéria prima cadastrada com sucesso.`,
                'X',
                {
                  duration: 2000,
                  horizontalPosition: 'right',
                  verticalPosition: 'top',
                  panelClass: ['msg-success']
                }
              );
              this.dialogRef.close(materia_prima);
            }
          },
          (err: HttpErrorResponse) => {
            this.displayError(err);
            this.loading = false;
          },
          () => {
            this.loading = false;
          }
        );
    }
  }

  /**
   * Verifica se a materia prima já foi cadastrada
   */
  public verificarNome(): void {
    const controlNome = this.form.controls.descricao;

    if (controlNome.invalid || controlNome.value === '') return;
    this.loading = true;

    const nome = controlNome.value;

    this.entityService
      .getEntitiesByParams({
        where: {
          descricao: controlNome.value,
          domain_id: this.tokenService.getDomain().id
        },
        list_options: 'ACTIVE_AND_INACTIVE'
      })
      .pipe(
        finalize(() => {
          this.loading = false;
        }),
        map(materia_primas => {
          if (!materia_primas || !materia_primas.length)
            return {} as IMateriaPrima;
          return materia_primas[0];
        }),
        filter(materia_prima => materia_prima && materia_prima.id)
      )
      .subscribe(
        materia_prima => {
          controlNome.setErrors({ repeated: true });
          // this.matSnackBar.open(
          //   `Já existe uma matéria prima com a mesma descrição: ${materia_prima.descricao}`,
          //   'X',
          //   {
          //     duration: 2000,
          //     horizontalPosition: 'right',
          //     verticalPosition: 'top',
          //     panelClass: ['msg-error']
          //   }
          // );
        },
        (err: HttpErrorResponse) => this.displayError(err)
      );
  }

  validateOnlyNumbers(event) {
    if (
      !/^\d+$/.test(event.key) &&
      !/[`.,]/.test(event.key) &&
      !event.ctrlKey &&
      event.key !== 'Backspace' &&
      event.key !== 'Delete' &&
      event.key !== 'Tab' &&
      event.key !== 'ArrowLeft' &&
      event.key !== 'ArrowRight'
    )
      return false;
  }

  markAllControlsAsDirty() {
    Object.keys(this.form.controls).forEach(controlKey => {
      controlKey = String(controlKey);
      const control = this.form.get(controlKey);
      if (!control || control.valid) return;
      control.markAsDirty();
    });
  }

  validateForm() {
    this.form.markAllAsTouched();
    this.markAllControlsAsDirty();
  }

  checkDisponibilidade(action: string, params = '', url_name: string) {
    var routesAuthorization = this.verificarRotasDeAcesso(
      this.tokenService.getRoutes(),
      url_name
    ) as IRoute[];

    return this.validarAdicao(routesAuthorization, action, params, url_name);
  }

  /**
   * Valida as rotas do usuário
   * @param routes
   * @param url_name
   * @returns
   */
  verificarRotasDeAcesso(routes: IRoute[], url_name: string): IRoute[] {
    if (routes && routes.length > 0 && url_name) {
      return routes.filter(r => new RegExp(`^${url_name}`).test(r.url));
    }
  }

  /**
   * Valida se as rotas do usuário são equivalentes ao pacote de rotas do fiscal
   * @param routesAuthorization
   * @param action
   * @param params
   * @param url_name
   * @returns
   */
  validarAdicao(
    routesAuthorization: IRoute[],
    action: string,
    params = '',
    url_name: string
  ): boolean {
    if (routesAuthorization && routesAuthorization.length > 0) {
      const url_return = routesAuthorization.find(
        route => route.url === url_name && route.method === action
      );
      return !!url_return;
    }
  }

  displayError(err: HttpErrorResponse, showDefaultMsg = false) {
    const errorMsg = new ErroMessages({
      route: this.router.url,
      router: this.router,
      matSnackBar: this.matSnackBar,
      httpError: err,
      showDefaultMsg: showDefaultMsg,
      loginService: null,
      tokenService: this.tokenService,
      dialogComponent: ConfirmDialogComponent,
      matDialog: this.matDialog,
      dialogData: {
        config: {
          data: {
            title: 'Aviso - Erro ao realizar operação',
            bodyMessage: err.error,
            icon: 'warning',
            icon_color: 'accent',
            singleBtn: true
          } as ConfirmDialogData,
          disableClose: true,
          width: '500px'
        } as MatDialogConfig<any>
      }
    } as IErroMessages);
    errorMsg.showMessageObject(err.error);
    // errorMsg.checkError();
  }
}
